import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function SiteLayout({ children, protect = true }) {
  const location = useLocation();

  // Copy protection for public pages only
  useEffect(() => {
    if (!protect) return;
    const onContext = (e) => { e.preventDefault(); };
    const onKey = (e) => {
      const k = e.key?.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (k === "c" || k === "a" || k === "x" || k === "s" || k === "u" || k === "p")) {
        // Allow inputs & textareas
        const tag = document.activeElement?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        e.preventDefault();
      }
      // Block F12/DevTools shortcut (best-effort)
      if (k === "f12") e.preventDefault();
    };
    const onCopy = (e) => {
      const tag = document.activeElement?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;
      e.preventDefault();
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    document.addEventListener("copy", onCopy);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("copy", onCopy);
    };
  }, [protect]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={protect ? "nv-protect min-h-screen flex flex-col bg-[#FDFCF8] nv-noise" : "min-h-screen flex flex-col bg-[#FDFCF8]"}>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
